<template>
  <label
    :class="[
      'label inline-flex grow-0 basis-auto uppercase',
      {
        'text-xs font-semibold': theme === 'default',
        'text-2xs -mb-2 font-semibold text-base-300': theme === 'light',
        'text-base font-bold': theme === 'bold',
        'text-base font-normal normal-case': theme === 'regular',
        'text-base normal-case text-primary': theme === 'primary',
      },
    ]"
    :for="props.for"
  >
    <slot></slot>
  </label>
</template>

<script lang="ts" setup>
  export interface MLabelProps {
    for?: string;
    theme?: 'default' | 'light' | 'bold' | 'regular' | 'primary';
  }

  const props = withDefaults(defineProps<MLabelProps>(), {
    theme: 'default',
    for: undefined,
  });
</script>
